import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the forgotPage state domain
 */

const selectForgotPageDomain = (state: ApplicationRootState) => {
  return state ? state.forgotPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by ForgotPage
 */

const selectForgotPage = () =>
  createSelector(selectForgotPageDomain, substate => {
    return substate;
  });

export default selectForgotPage;
export { selectForgotPageDomain };
